import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class CatalogueItem extends Component {
  render() {
    const catItem = this.props.item;

    if (!catItem) {
      return null;
    }

    const path = `/wellness/elibrary/catalogue/${catItem.detailsKey}`;

    return (
      <article className="grid__item grid__item--three apl-showcase__item">
        {catItem.imageMainFull &&
          <figure>
            <Link to={path}>
              <img src={catItem.imageMainFull} alt="" />
            </Link>
          </figure>}
        <header>
          <h4>
            <Link to={path}>
              {catItem.title}
            </Link>
          </h4>
        </header>
        <section>
          <p>
            {catItem.providerName}
          </p>
          <div dangerouslySetInnerHTML={{ __html: catItem.summary }} />
        </section>
      </article>
    );
  }
}

CatalogueItem.propTypes = { item: PropTypes.object };

export default CatalogueItem;



// WEBPACK FOOTER //
// ./components/elibrary/CatalogueItem.js